import { Routes } from '@angular/router';

export const routes: Routes = [
    {
      path: '',
      loadChildren: () => import('./features/features-routing').then((m) => m.routes),
    }, 
    { path: '**', redirectTo: '', pathMatch: 'prefix' },
  ];
